import { getApi } from "./api_instance";

const sidenav = async (logout) => {
  try {
    return await getApi({
      apiUrl: "/admin/api/user/list/sidenav",
      sendToken: true,
      logout,
    });
  } catch (error) {
    throw error;
  }
};

export default sidenav;
